export default __webpack_public_path__ + "tab5_video_posterb0b9c9.png";